import React, { ReactElement } from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { htmlT } from 'utils/generic';

import { Container, IconShield } from './styles';

interface Props {
  icon?: JSX.Element;
  text?: JSX.Element[] | ReactElement[] | string;
}
const AutoBoxIcon = ({ icon, text }: Props) => {
  const { t } = useStoreTranslation();

  return (
    <Container>
      <Container.Icon>{icon ? icon : <IconShield />}</Container.Icon>
      <Container.Content>
        <p>{text ? text : htmlT(t, 'autosDetails.insurance')}</p>
      </Container.Content>
    </Container>
  );
};

export default AutoBoxIcon;
